import { createContext } from 'react';

const AppContext = createContext({
  appIsLoading: null,
  setAppIsLoading: null,
});

export default AppContext;
